import { useState, useCallback } from 'react';
import { pwd210Api, FD210 } from '../../../services/pwd210Api';

export function usePwd210Lookup() {
  const [names, setNames] = useState<Record<string, string>>({});

  /** Batch-resolve all lookup names for master record */
  const resolveAllNames = useCallback(async (data: Partial<FD210>) => {
    const entries: [string, string, string][] = [
      ['entryPerson', 'employee', data.fd210_12 || ''],
      ['vendor', 'vendor', data.fd210_31 || ''],
      ['packing', 'packing', data.fd210_33 || ''],
    ];
    const results = await Promise.all(
      entries.map(([key, type, code]) =>
        pwd210Api.lookupName(type, code).then(name => [key, name] as [string, string])
      )
    );
    setNames(prev => {
      const next = { ...prev };
      for (const [key, name] of results) next[key] = name;
      return next;
    });
  }, []);

  /** Resolve a single lookup name (for onBlur events) */
  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    const name = await pwd210Api.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  /** Clear all cached names */
  const clearNames = useCallback(() => {
    setNames({});
  }, []);

  return { names, resolveAllNames, resolveSingleName, clearNames };
}
